import {AfterViewInit, Component, HostListener, OnInit} from '@angular/core';

import { BaseService } from '../../../services/base.service';
import { AuthService } from '../../../services/auth.service';
import * as moment from 'moment';
import { SERVER_DATE_FORMAT_WITH_TIME, SERVER_DATE_FORMAT_WITHOUT_TIME } from '../../../config/date_format';
import { ActivatedRoute } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { User } from '../../../models/user';
import { TrackingLocation } from '../../../models/tracking-location';
import swal from 'sweetalert2';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/internal/operators';
import { Market } from '../../../models/market';
import { MarketLevel } from '../../../models/market-level';
import { MatSelectChange } from '@angular/material';
import {UserRole} from '../../../models/user-role';
import {Title} from '@angular/platform-browser';
import { TitleBroadcastService } from 'app/services/title-broadcast.service';

@Component({
  selector: 'app-user-last-location-list',
  templateUrl: './user-last-location-list.component.html',
  styleUrls: ['./user-last-location-list.component.scss']
})
export class UserLastLocationListComponent implements OnInit {


    lat = 23.8383283;
    lng = 90.3759853;

    loggedUser: User;

    locationList: TrackingLocation[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    userRoles: UserRole[];
    filters = {
        'FromDateTime': null,
        'ToDateTime'  : null,
        'FromDate'      : moment().set( { hour: 0, minute: 0, second: 0 } ).format( SERVER_DATE_FORMAT_WITHOUT_TIME ),
        'ToDate'        : moment().set( { hour: 23, minute: 59, second: 59 } ).format( SERVER_DATE_FORMAT_WITHOUT_TIME ),
        'MarketIdList': null,
        'Only'        : null,
        'SearchKey'   : null,
        'UserRoleId'  : null
    };

    userType = 'ORGANIZATION_USER';


    // tslint:disable-next-line:typedef
    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.getLocationList();
        }
    }

    private _unsubscribeAll: Subject<any>;

    constructor( private route: ActivatedRoute, private service: BaseService, private auth: AuthService, private titleService: Title, private titleBroadcastService: TitleBroadcastService  ) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('User Last Location Tracking');
        this.loggedUser = auth.user;
        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        this.marketLevels.forEach( marketLevel => {
            this.markets[ marketLevel.Rank ] = [];
            this.selectedMarket[ marketLevel.Rank ] = null;
        } );
    }

    ngOnInit(): void {
        this.titleService.setTitle('User Last Location Tracking');
        this.service.getUserRoleList( { } ).subscribe( pUserRoles => this.userRoles = pUserRoles );
        this.service.getMarketList( { MarketLevelId: this.marketLevels[ 0 ].Id, Active: true } ).subscribe( pMarkets => this.markets[ 1 ] = pMarkets );
    }

    ngAfterViewInit(): void {
        this.service.getMarketList( {
            MarketLevelId: this.marketLevels[ 0 ].Id,
            Active       : true
        } ).subscribe( marketListResponse => {
            this.markets[ 1 ] = marketListResponse;
        } );
    }


    setFromDate( pEvent ): void {
        const eventDate = moment( pEvent.value );
        eventDate.set( 'hour', 0 );
        eventDate.set( 'minute', 0 );
        eventDate.set( 'second', 0 );
        this.filters.FromDate = moment( eventDate ).format( SERVER_DATE_FORMAT_WITHOUT_TIME );
    }

    setToDate( pEvent ): void {
        const eventDate = moment( pEvent.value );
        eventDate.set( 'hour', 23 );
        eventDate.set( 'minute', 59 );
        eventDate.set( 'second', 59 );
        this.filters.ToDate = moment( eventDate ).format( SERVER_DATE_FORMAT_WITHOUT_TIME );
    }

    _resetChildrenDropdown( pParentRank: number ): void {
        this.marketLevels.forEach( pMarketLevel => {
            if ( pMarketLevel.Rank > pParentRank ) {
                this.selectedMarket[ pMarketLevel.Rank ] = null;
                this.markets[ pMarketLevel.Rank ] = [];
            }
        } );
    }

    populateChildrenMarkets( event: MatSelectChange ): void {
        const market: Market = event.value;
        if ( market ) {
            this._resetChildrenDropdown( market.MarketRank );
            if ( this.marketLevels[ market.MarketRank ] ) {
                this.service.getMarketList( { MarketLevelId: this.marketLevels[ market.MarketRank ].Id, ParentMarketId: market.Id, Active: true } ).subscribe( pMarketList => this.markets[ market.MarketRank + 1 ] = pMarketList );
            }
        }
        else {
            this._resetChildrenDropdown( parseInt( event.source.id.slice( 6 ), 10 ) );
        }
    }



    getLocationList(): void {
        this.filters.MarketIdList = null;
        for ( let i = this.selectedMarket.length - 1; i >= 0; i-- ) {
            if ( this.selectedMarket[ i ] ) {
                this.filters.MarketIdList = [ this.selectedMarket[ i ].Id ];
                break;
            }
        }

        this.loadingData = true;
        this.service.getUserLastLocationList( this.filters ).subscribe( locationList => {
            this.loadingData = false;
            if ( locationList.length > 0 ) {
                this.lat = locationList[ 0 ].Latitude;
                this.lng = locationList[ 0 ].Longitude;
            }

            this.locationList = locationList;
        }, error => {
            this.loadingData = false;
        } );
    }

}
